import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=04af6d5a&scoped=true&"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af6d5a",
  null
  
)

export default component.exports